module.exports = { 
  content: { 
    main: "欢迎来到 CERESHOP", 
    titleLogin: "登录",
    titleRegister: "注册",
    phoneNumber: "手机号码",
    phoneNumberPlaceholder: "请输入您的手机号码",
    verificationCode: "验证码",
    verificationCodePlaceholder: "请输入验证码",
    getCode: '获取验证码',
    again: '重新获取',
    sevenDay: '七天免登录',
    agree: "阅读并同意",
    serviceAgreement: "服务协议",
  } 
} 


// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/login.js